import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { AuthHttpService } from '@app/core/services/http/auth/auth.service';

/**
 * /admin → стартовая страница пользователя. Обычный redirectTo срабатывает до guard'ов,
 * когда GET /b2b/me/context еще не загружен, — а от режима сотрудничества агента зависит,
 * куда его вести (маркетинг или продажи). Поэтому сначала дожидаемся контекста.
 */
export const homeRedirectGuard: CanActivateFn = () => {
  const auth = inject(AuthHttpService);
  const router = inject(Router);
  return auth.loadB2bContext().pipe(map(() => router.createUrlTree(auth.getHomeRoute())));
};
